(function () {
  'use strict';

  /* @ngdoc object
   * @name itecAdministracio.shared.estat
   * @description
   *
   */
  angular
    .module('itecAdministracio.shared.headerSubmenu', []);
}());
